import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ja from "./locales/ja.json";

export const resources = {
  en: { translation: en },
  ja: { translation: ja },
} as const;

// Detect language from browser
const getBrowserLanguage = (): string => {
  const browserLang = navigator.language.split("-")[0];
  return browserLang === "ja" ? "ja" : "en";
};

i18n.use(initReactI18next).init({
  resources,
  lng: getBrowserLanguage(),
  fallbackLng: "en",
  debug: import.meta.env.DEV,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
  initImmediate: false,
});

export default i18n;
